import UserStore from './user_store';

import util from '../tools/util';

export default {
  fetchDeviceAuth,
  checkHash,
  addFilestoreObject,
  addS3Object,
};

function fetchDeviceAuth(
  params: any,
  done: (err: any, device_auth?: string) => void
) {
  const { org_id } = params;
  const opts = {
    url: `/api/1/device/my`,
  };
  UserStore.get(opts, (err, body) => {
    let auth;
    if (err) {
      util.errorLog('DeviceStore.fetch: err:', err);
    } else if (body) {
      body.device_list.forEach((device) => {
        const { device_session_key } = device;
        if (device_session_key && device.org_id === org_id) {
          console.log('auth:', auth);
          auth = device_session_key;
        }
      });
      if (!auth) {
        err = 'no_auth';
      }
    }
    done(err, auth);
  });
}

function checkHash(params, done) {
  const { volume_id, file_hash, file_size } = params;
  const opts = {
    url: `/api/1/device_hash_sync/check_hash`,
    query: {
      volume_id,
      file_hash,
      file_size,
    },
    retry: true,
  };
  UserStore.get(opts, (err, body) => {
    if (err) {
      util.errorLog('DeviceHashStore.checkHash: err:', err);
    }
    done(err, body);
  });
}

function addFilestoreObject(params, done) {
  const { volume_id, file_hash, expire_time } = params;
  const opts = {
    url: '/api/1/filestore_object',
    body: {
      volume_id,
      file_hash,
      expire_time,
    },
    retry: true,
  };
  UserStore.post(opts, (err, body) => {
    if (err) {
      util.errorLog('DeviceHashStore.addFilestoreObject: err:', err, body);
    }
    done(err);
  });
}
function addS3Object(params, done) {
  const { file_hash, file_size } = params;
  const opts = {
    url: '/api/1/s3_object',
    body: {
      file_hash,
      file_size,
    },
    retry: true,
  };
  UserStore.post(opts, (err, body) => {
    if (err) {
      util.errorLog(
        'DeviceHashStore.addS3Object: put object err:',
        err,
        body,
        file_hash
      );
    }
    done(err);
  });
}
